const RESOLUTION_BASE = "https://redirect.invalid";

const FALLBACK_PATH = "/";

export const sanitizeRedirectPath = (
  path: string | null | undefined,
): string => {
  if (!path) return FALLBACK_PATH;

  let resolved: URL;
  try {
    resolved = new URL(path, RESOLUTION_BASE);
  } catch {
    return FALLBACK_PATH;
  }

  if (resolved.origin !== RESOLUTION_BASE) return FALLBACK_PATH;

  const target = resolved.pathname + resolved.search + resolved.hash;
  // `/..//evil.com` passes the origin check but is protocol-relative to a navigator.
  if (!target.startsWith("/") || target.startsWith("//")) return FALLBACK_PATH;

  return target;
};
